import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots } from "vue";
import { computed, useSlots } from 'vue';
export default {
  __name: 'LlTooltip',
  props: {
    text: {
      type: String,
      default: undefined
    },
    location: {
      type: String,
      default: 'end'
    },
    maxWidth: {
      type: [String, Number],
      default: undefined
    },
    icon: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const slots = useSlots();
    const props = __props;
    const hasContent = computed(() => !props.disabled && (!!props.text || !!slots.default));
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_tooltip = _resolveComponent("v-tooltip");
      return hasContent.value ? (_openBlock(), _createBlock(_component_v_tooltip, {
        key: 0,
        text: _unref(slots).default ? undefined : __props.text,
        location: __props.location,
        "max-width": __props.maxWidth,
        class: _normalizeClass({
          'no-print': __props.icon
        })
      }, _createSlots({
        activator: _withCtx(({
          props: activatorProps
        }) => [_createElementVNode("span", _mergeProps(activatorProps, {
          class: {
            'no-print': __props.icon
          }
        }), [_renderSlot(_ctx.$slots, "activator", {}, () => [__props.icon === 'warning' ? (_openBlock(), _createBlock(_component_v_icon, {
          key: 0,
          icon: "mdi-alert",
          size: "14",
          class: "ll-info"
        })) : __props.icon ? (_openBlock(), _createBlock(_component_v_icon, {
          key: 1,
          icon: "mdi-help-circle",
          size: "14",
          class: "ll-info"
        })) : _createCommentVNode("", true)])], 16)]),
        _: 2
      }, [_unref(slots).default ? {
        name: "default",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        key: "0"
      } : undefined]), 1032, ["text", "location", "max-width", "class"])) : _renderSlot(_ctx.$slots, "activator", {
        key: 1
      });
    };
  }
};